module.exports = __webpack_public_path__ + "img/report.3ef5ed45.svg";